import { createRoot } from 'react-dom/client'
import App from '@react/offices/components/App'
import { AppProvider } from '@react/offices/Context'

const rootNode = document.getElementById('offices-app')

const data = JSON.parse(document.getElementById('offices-data').textContent)

const root = createRoot(rootNode)

root.render(
  <AppProvider>
    <App data={data} />
  </AppProvider>
)
